import { INPUT_TYPE } from "../../constants/Constant";
import { INPUT_VIEW_DIRECTION } from "../SequenceNumberFormat/Other";

export const GENERAL_SETTING_FORM = [
    {
        key:"policyName",
        columnCode: "policyName",
        options:[],
        icon:"",
        validation:{
            regExp:`^.{1,60}$`
        },
        isValid:true,
        name:"Policy Name",
        type:INPUT_TYPE.TEXT,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true,
        tooltipText: "The policy name must not exceed 60 characters." 
    },
    {
        key:"description",
        columnCode: "description",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Policy Description",
        type:INPUT_TYPE.TEXT,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true,
        tooltipText: "Enter a short description of the policy."
    },
    {
        key:"applicableToAll",
        columnCode: "applicableToAll",
        options:[{id:'true',name:"Yes"},{id:'false',name:"No"}],
        icon:"",
        validation:null,
        isValid:true,
        name:"Applicable to All",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"employees",
        columnCode: "employees",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Employees in the Policy",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: false,
        uiVisible: true,
        multiSelect: true,
        errorMessage:"employees in the selected policy already part of another active policy"
    }
]

export const ELIGIBILITY_SETTING_FORM = [
    {
        key:"breakHours",
        columnCode: "breakHours",
        name: "Break Hours",
        subFields:[
            {
                key:"all",
                columnCode: "all",
                options:[],
                icon:"",
                validation:null,
                isValid:true,
                name:"All",
                type:'date-time-input',
                errorMessage:null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required:true,
                readOnly: false,
                uiVisible: true,
                tooltipText: null
            },
            {
                key:"restDay",
                columnCode: "restDay",
                options:[],
                icon:"",
                validation:null,
                isValid:true,
                name:"Rest Day",
                type:'date-time-input',
                errorMessage:null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required:true,
                readOnly: false,
                uiVisible: true,
                tooltipText: null
            },
            {
                key:"offDay",
                columnCode: "offDay",
                options:[],
                icon:"",
                validation:null,
                isValid:true,
                name:"Off Day",
                type:'date-time-input',
                errorMessage:null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required:true,
                readOnly: false,
                uiVisible: true,
                tooltipText: null
            },
            {
                key:"holiday",
                columnCode: "holiday",
                options:[],
                icon:"",
                validation:null,
                isValid:true,
                name:"Holiday",
                type:'date-time-input',
                errorMessage:null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required:true,
                readOnly: false,
                uiVisible: true,
                tooltipText: null
            },
            {
                key:"regularDay",
                columnCode: "regularDay",
                options:[],
                icon:"",
                validation:null,
                isValid:true,
                name:"Regular Day",
                type:'date-time-input',
                errorMessage:null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required:true,
                readOnly: false,
                uiVisible: true,
                tooltipText: null
            },
            {
                key:"halfDay",
                columnCode: "halfDay",
                options:[],
                icon:"",
                validation:null,
                isValid:true,
                name:"Half Day",
                type:'date-time-input',
                errorMessage:null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required:true,
                readOnly: false,
                uiVisible: true,
                tooltipText: null
            }
        ]
    },
    
    {
        key:"maxOvertime",
        columnCode: "maxOvertime",
        name:"Maximum Overtime",
        subFields:[
            {
                key:"daily",
                columnCode: "daily",
                options:[],
                icon:"",
                validation:null,
                isValid:true,
                name:"Daily",
                type:'date-time-input',
                errorMessage:null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required:true,
                readOnly: false,
                uiVisible: true,
                tooltipText: null
            },
            {
                key:"weekly",
                columnCode: "weekly",
                options:[],
                icon:"",
                validation:null,
                isValid:true,
                name:"Weekly",
                type:'date-time-input',
                errorMessage:null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required:true,
                readOnly: false,
                uiVisible: true,
                tooltipText: null,
                hasMaxHours:168
            },
            {
                key:"monthly",
                columnCode: "monthly",
                options:[],
                icon:"",
                validation:null,
                isValid:true,
                name:"Monthly",
                type:'date-time-input',
                errorMessage:null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required:true,
                readOnly: false,
                uiVisible: true,
                tooltipText: null,
                hasMaxHours:744
            },
            {
                key:"quarterly",
                columnCode: "quarterly",
                options:[],
                icon:"",
                validation:null,
                isValid:true,
                name:"Quarterly",
                type:'date-time-input',
                errorMessage:null,
                direction: INPUT_VIEW_DIRECTION.VERTICAL,
                required:true,
                readOnly: false,
                uiVisible: true,
                tooltipText: null,
                hasMaxHours:2880
            }
        ]
    },
    {
        key:"minHours",
        columnCode: "minHours",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"A. Minimum hours for overtime eligibility",
        type:'date-time-input',
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"blockTime",
        columnCode: "blockTime",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"B. Block time for overtime calculation",
        type:INPUT_TYPE.NUMBER,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true,
        tooltipText: "Enter Block time in minutes." 
    },
    {
        key:"otToRoundOff",
        columnCode: "otToRoundOff",
        options:[{id:"ROUND_UP",name:"Round Up"}, {id:"ROUND_DOWN",name:'Round Down'}, {id:"NORMAL_ROUND",name:'Normal Round'}, {id:"NO_ROUND_OFF",name:'No Round-off'}],
        icon:"",
        validation:null,
        isValid:true,
        name:"C. Overtime round off to block time",
        type:INPUT_TYPE.DROPDOWN,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"hasExpiry",
        columnCode: "hasExpiry",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Overtime Has Expiry ",
        type:INPUT_TYPE.CHECKBOX,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"actionDue",
        columnCode: "actionDue",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Action Due",
        type:INPUT_TYPE.NUMBER,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:true,
        readOnly: false,
        uiVisible: false,
        tooltipText: "You have activated Overtime Expiry, please enter a valid number of expiry days." 
    },
    {
        key:"actionDueDate",
        columnCode: "actionDueDate",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Expiry Date",
        type:INPUT_TYPE.DATE,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: true,
        uiVisible: false
    }
]

export const PAYOUT_SETTING_FORM = [
  {
    key: "otMultiplier",
    columnCode: "otMultiplier",
    name: "Overtime Payroll Multiplier",
    subFields: [
      {
        key: "multiplierAll",
        columnCode: "multiplierAll",
        options: [],
        icon: "",
        validation: null,
        isValid: true,
        name: "All",
        type: INPUT_TYPE.DROPDOWN,
        errorMessage: null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required: false,
        readOnly: false,
        uiVisible: true,
        tooltipText: null,
        buttonConfig: {
          title: "+ Add Overtime Payroll Multiplier",
          className: "bg-app text-white",
        },
      },
      {
        key: "multiplierRestDay",
        columnCode: "multiplierRestDay",
        options: [],
        icon: "",
        validation: null,
        isValid: true,
        name: "Rest Day",
        type: INPUT_TYPE.DROPDOWN,
        errorMessage: null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required: true,
        readOnly: false,
        uiVisible: true,
        tooltipText: null,
        buttonConfig: {
          title: "+ Add Overtime Payroll Multiplier",
          className: "bg-app text-white",
        },
      },
      {
        key: "multiplierOffDay",
        columnCode: "multiplierOffDay",
        options: [],
        icon: "",
        validation: null,
        isValid: true,
        name: "Off Day",
        type: INPUT_TYPE.DROPDOWN,
        errorMessage: null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required: true,
        readOnly: false,
        uiVisible: true,
        tooltipText: null,
        buttonConfig: {
          title: "+ Add Overtime Payroll Multiplier",
          className: "bg-app text-white",
        },
      },
      {
        key: "multiplierHoliday",
        columnCode: "multiplierHoliday",
        options: [],
        icon: "",
        validation: null,
        isValid: true,
        name: "Holiday",
        type: INPUT_TYPE.DROPDOWN,
        errorMessage: null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required: true,
        readOnly: false,
        uiVisible: true,
        tooltipText: null,
        buttonConfig: {
          title: "+ Add Overtime Payroll Multiplier",
          className: "bg-app text-white",
        },
      },
      {
        key: "multiplierRegularDay",
        columnCode: "multiplierRegularDay",
        options: [],
        icon: "",
        validation: null,
        isValid: true,
        name: "Regular Day",
        type: INPUT_TYPE.DROPDOWN,
        errorMessage: null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required: true,
        readOnly: false,
        uiVisible: true,
        tooltipText: null,
        buttonConfig: {
          title: "+ Add Overtime Payroll Multiplier",
          className: "bg-app text-white",
        },
      },
      {
        key: "multiplierHalfDay",
        columnCode: "multiplierHalfDay",
        options: [],
        icon: "",
        validation: null,
        isValid: true,
        name: "Half Day",
        type: INPUT_TYPE.DROPDOWN,
        errorMessage: null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required: true,
        readOnly: false,
        uiVisible: true,
        tooltipText: null,
        buttonConfig: {
          title: "+ Add Overtime Payroll Multiplier",
          className: "bg-app text-white",
        },
      },
    ],
  },
  {
    key: "calculationType",
    columnCode: "calculationType",
    options: [
      { id: "DAY_TYPE", name: "Day Type" },
      { id: "SHIFT", name: "Shift" },
    ],
    icon: "",
    validation: null,
    isValid: true,
    name: "Calculation Type",
    type: INPUT_TYPE.DROPDOWN,
    errorMessage: null,
    direction: INPUT_VIEW_DIRECTION.VERTICAL,
    required: true,
    readOnly: false,
    uiVisible: true,
  },
  {
    key: "calculationMethod",
    columnCode: "calculationMethod",
    options: [
      { id: "FLAT", name: "<b>Flat</b>" },
      { id: "COMPONENT", name: "Component" }
    ],
    icon: "",
    validation: null,
    isValid: true,
    name: "Overtime Calculation Method",
    type: INPUT_TYPE.DROPDOWN,
    errorMessage: null,
    direction: INPUT_VIEW_DIRECTION.VERTICAL,
    required: true,
    readOnly: false,
    uiVisible: true,
  },
  {
    key: "flatAmount",
    columnCode: "flatAmount",
    options: [],
    icon: "",
    validation: null,
    isValid: true,
    name: "Flat Amount",
    type: INPUT_TYPE.NUMBER,
    errorMessage: null,
    direction: INPUT_VIEW_DIRECTION.VERTICAL,
    required: true,
    readOnly: false,
    uiVisible: true,
  },
  {
    key: "component",
    columnCode: "component",
    options: [],
    icon: "",
    validation: null,
    isValid: true,
    name: "Component",
    type: INPUT_TYPE.DROPDOWN,
    errorMessage: null,
    direction: INPUT_VIEW_DIRECTION.VERTICAL,
    required: true,
    readOnly: false,
    uiVisible: false,
    tooltipText:
      "Please ensure components are assigned to the employees when mapping component based policy. If not mapped, employees will not get any overtime.",
  },
];
export const RATE_MULTI_OT_COLUMN = [
                    
    {
        id: "JUgM",
        index: 1,
        type: "number",
        name: "OT",
        key: 'value',
        columnCode: "value",
        editable: true,
        hidden: false,
        options: null,
        required: true,
        systemField: true,
        uiVisible: true,
        width: 150,
        allowFilter: false
    }
]
export const OVERTIME_IMPORTANT_DETAILS = [
    {
        key:"effectiveFrom",
        columnCode: "effectiveFrom",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Effective From",
        type:INPUT_TYPE.DATE,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"employeeCount",
        columnCode: "employeeCount",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Assigned Employees",
        type:INPUT_TYPE.TEXT,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"updatedAt",
        columnCode: "updatedAt",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Last Modified Date",
        type:INPUT_TYPE.DATE,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"updatedBy",
        columnCode: "updatedBy",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Last Modified By",
        type:INPUT_TYPE.TEXT,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"createdBy",
        columnCode: "createdBy",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Created By",
        type:INPUT_TYPE.TEXT,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: true,
        uiVisible: false
    },
    {
        key:"createdAt",
        columnCode: "createdAt",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Created Date",
        type:INPUT_TYPE.DATE,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: true,
        uiVisible: false
    },
    {
        key:"remark",
        columnCode: "remark",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Remark",
        type:INPUT_TYPE.TEXT,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.VERTICAL,
        required:false,
        readOnly: false,
        uiVisible: true
    }
];

export const OVERTIME_ACTIVATE_POPUP_FORM = [
    {
        key:"effectiveFrom",
        columnCode: "effectiveFrom",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Effective From",
        type:INPUT_TYPE.DATE,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:true,
        readOnly: false,
        uiVisible: true
    },
    {
        key:"remark",
        columnCode: "remark",
        options:[],
        icon:"",
        validation:null,
        isValid:true,
        name:"Remark",
        type:INPUT_TYPE.TEXT,
        errorMessage:null,
        direction: INPUT_VIEW_DIRECTION.HORIZONTAL,
        required:false,
        readOnly: false,
        uiVisible: true
    }
];
export const SHOW_MINIMUM_NO_LIST = 3;

export const FIELD_TO_DISPLAY_IN_UNSELECTED_RULE = ['policyName','description','breakHours','maxOvertime','minHours','blockTime','otToRoundOff','calculationType','calculationMethod','employeeCount','status','remark','actionDue','flatAmount','component','multiplier']
export const POLICY_STATUS = {
    ACTIVE: "ACTIVE",
    DRAFT: "DRAFT"
}
export const DEFALUT_EFFECTIVE_DATE = "0001-01-01T00:00:00Z";